import { useMutation, useQuery } from '@tanstack/react-query';

import {
  abTestApi,
  type ABTestSessionResponse,
  type ABTestVariantInput,
  type StartABTestResponse,
} from '../services/abTestApi';

export function useStartABTest(agentId: string | undefined) {
  return useMutation<
    StartABTestResponse,
    Error,
    { variants: ABTestVariantInput[]; scenarioType: 'quick' | 'full' }
  >({
    mutationFn: ({ variants, scenarioType }) => {
      if (!agentId) throw new Error('agentId required');
      return abTestApi.start(agentId, variants, scenarioType);
    },
  });
}

export function useABTestSession(
  agentId: string | undefined,
  sessionId: string | undefined,
) {
  return useQuery<ABTestSessionResponse>({
    queryKey: ['ab-test-session', agentId, sessionId],
    queryFn: () => abTestApi.getSession(agentId!, sessionId!),
    enabled: !!agentId && !!sessionId,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return 1500;
      if (data.status === 'pending' || data.status === 'running') return 1500;
      return false;
    },
  });
}

export function useApplyABTestVariant(agentId: string | undefined) {
  return useMutation<void, Error, { sessionId: string; variantId: string }>({
    mutationFn: ({ sessionId, variantId }) => {
      if (!agentId) throw new Error('agentId required');
      return abTestApi.applyVariant(agentId, sessionId, variantId);
    },
  });
}
